/** Leadzai whitelabel theme entry. */

import type { WhitelabelThemeEntry } from '../../types';
import { leadzaiDefaultTheme } from './default';
import { leadzaiCoralTheme } from './coral';
import { leadzaiTealTheme } from './teal';

export { leadzaiWhitelabel } from './default';

export const leadzaiWhitelabelThemeEntry: WhitelabelThemeEntry = {
  themes: {
    default: leadzaiDefaultTheme,
    coral: leadzaiCoralTheme,
    teal: leadzaiTealTheme,
  },
};
